import { registerEnumSet } from '@if/mui'
import { CheckCircle2, CircleAlert, FileText, PencilLine, UserRoundCheck, Wallet } from 'lucide-react'
import { ECurrentCustomerStep } from '../Constants'
import '../../containers/ViewCreditApplicationPage/creditStatusEnumSet'

// Registers the credit-application steps in the shared @if/mui enum registry, so any
// surface can render a step chip via `type: 'enumChip'` (DataGridPage) or the enum-chip
// components. The 4th arg is the ordered flow, which lets a surface render the step as
// an `<EnumStepper>` / `type: 'enumStepper'` (dot-stepper) instead of a chip. Global,
// load-once side-effect — import once at app bootstrap regardless of which page mounts.
registerEnumSet(
  ECurrentCustomerStep,
  {
    [ECurrentCustomerStep.Draft]: { color: 'info', icon: PencilLine, labelKey: 'creditStatus.draft' },
    [ECurrentCustomerStep.Prequal]: { color: 'purple', icon: UserRoundCheck, labelKey: 'creditStatus.prequal' },
    [ECurrentCustomerStep.Credit]: { color: 'success', icon: CheckCircle2, labelKey: 'creditStatus.credit' },
    [ECurrentCustomerStep.IncomeVerification]: {
      color: 'warning',
      icon: CircleAlert,
      labelKey: 'creditStatus.incomeVerification',
    },
    [ECurrentCustomerStep.Contract]: { color: 'blue', icon: FileText, labelKey: 'creditStatus.contract' },
    [ECurrentCustomerStep.Funding]: { color: 'teal', icon: Wallet, labelKey: 'creditStatus.funding' },
  },
  undefined,
  // Draft is deliberately excluded — it's its own tab, not a stage on the rail.
  // A Draft application isn't in the flow, so the stepper reads as "not started".
  [
    ECurrentCustomerStep.Prequal,
    ECurrentCustomerStep.Credit,
    ECurrentCustomerStep.IncomeVerification,
    ECurrentCustomerStep.Contract,
    ECurrentCustomerStep.Funding,
  ],
)
